$(function() {
    toggleMenu();
    destroyDesktopPdpMediaSlider();
    initComplementarySlider();
    checkIncompleteBundle();
    initPdpHighlightSlider();
    updateAppBundleButton();
    updatePdpBundlePrice();
    performRecommendations();
    updateBundleSliderHeight();
    initSizeGuideSplide();
    updateCharmLimit();
    updateCharmOverlayImage();

    document.addEventListener('theme:cart:change', function() {
        performRecommendations();
        masterPromo();
    });
    $(window).on('load', function () {
        masterPromo();
    });

    setTimeout(() => {
      calculateCharmSetBundlePrice();
    }, 500);
});

// start: product highlights
initPdpHighlightSlider = () => {
    var $slider = $('.jsc-product-highlight-wrapper').find('.jsc-product-highlight');
    if($slider.length > 0) {
        var itemCount = $slider.find('.jsc-product-highlight-item').length;
        var windowWidth = $(window).width();

        if ((windowWidth <= 480 && itemCount > 3) || itemCount > 4) {
            $slider.flickity({
                prevNextButtons: false,
                pageDots: false,
                cellAlign: 'left',
                contain: true,
                wrapAround: false
            });
        }

    }
}

showHighlightPopup = (evt) => {
    var index = $(evt).find('.jsc-highlight-media-thumbnail').attr('data-index');
    var $popup = $('.jsc-product-highlight-popup[data-index="' + index + '"]');
    
    if($popup.length > 0) {
        var $allPopup = $('.jsc-product-highlight-popup');
        $allPopup.removeClass('active');
        $popup.find('.jsc-highlight-media-full')[0].currentTime = 0;
        $popup.addClass('active');
        $('#jsc-custom-chat-widget').addClass('hide-important');
        $popup.find('.jsc-highlight-media-full')[0].play();
        $popup.find('.jsc-highlight-media-full').prop('muted', false);
    }
}

updateHighlightPopupPosition = () => {
    var $container = $('#main .container');
    if($(window).width() > 1024 && $container.length > 0) {
        var containerRight = $('#main .container')[0].getBoundingClientRect().right;
        var containerPadding = parseInt($('#main .container').css('padding-right'));
        var windowWidth = $(window).width();
        if(containerRight < windowWidth) {
            var rightPos = windowWidth - containerRight + containerPadding;
            $('.jsc-product-highlight-popup').css('right', rightPos + 'px');
        }
    }
    
}

hideHighlightPopup = (evt) => {
    var $popup = $(evt).parent();
    $popup.removeClass('active');
    $('#jsc-custom-chat-widget').removeClass('hide-important');

    var $video = $popup.find('.jsc-product-highlight-media-popup video');
     if ($video.length > 0) {
        $video.prop('muted', true);
    }
}
// end: product highlights

// start: show megamenu on hover
toggleMenu = () => {
    var $menuButton = $('.jsc-menu-button');
    var $megamenu = $('.jsc-megamenu');

    if ($menuButton.length > 0) {
        $menuButton.on('mouseenter', function() {
            var counter = $(this).attr('data-counter');
            showMenu(counter, $(this));
            $('#headerContainer .logo-image .jsc-overlay_logo').addClass('opacity-100');
            $('#headerContainer .logo-image .jsc-overlay_logo').removeClass('opacity-0');
        });

        $megamenu.on('mouseleave', function() {
            closeMenu();
            $('#headerContainer .logo-image .jsc-overlay_logo').addClass('opacity-0');
            $('#headerContainer .logo-image .jsc-overlay_logo').removeClass('opacity-100');
        });
    }
}

showMenu = (counter, button) => {
    var $megamenu = $(button).siblings('.jsc-megamenu');
    var $header = $('.shopify-section-group-header-group data-island');

    if ($megamenu.length > 0) {
        closeMenu();
        $header.attr('data-color-scheme', 'scheme6');
        $header.addClass('bg-scheme-background');
        $header.removeClass('bg-scheme-background/0');
        $megamenu.show();
        $(button).find('.svg-scale').addClass('rotate-180');
    }
}

closeMenu = () => {
    var $megamenu = $('.jsc-megamenu');
    var $menuButton = $('.jsc-menu-button');
    var $header = $('.section-site-header data-island');
    var isSticky = $('.section-site-header').attr('is-sticky-active');

    if ($megamenu.length > 0) {
        if (window.location.pathname === '/' && isSticky == 'false') {
            console.log('run');
            $header.attr('data-color-scheme', 'scheme3');
            $header.removeClass('bg-scheme-background');
            $header.addClass('bg-scheme-background/0');
        }
        $megamenu.hide();
        $menuButton.find('.svg-scale').removeClass('rotate-180');
    }
}
// end: show megamenu on hover

// start: pdp media gallery
destroyDesktopPdpMediaSlider = () => {
    var $mediaGrid = $('.product-media .jsc-product-media-grid');
    if ($mediaGrid.length > 0 && $(window).width() > 820) {
        $mediaGrid.removeClass('splide');
    }
}

updateSliderProgress = () => {
    var $mediaSlider = $('.splide--product');
    if ($mediaSlider.length > 0) {
        var $progressBar = $mediaSlider.find('.jsc-splide-progress-bar');
        var slideCount = $mediaSlider.find('.feature-media-item').length;
        var $currentSlide = $mediaSlider.find('.feature-media-item.is-active');
        var index = parseInt($currentSlide.attr('data-index'));
        var progress = (index / slideCount) * 100;
        $progressBar.css('width', progress + '%');
        console.log('update progress', index);
    }
}
// end: pdp media gallery

// start: footer menu (mobile)
toggleAccordionMenu = (e) => {
    const accordionContent = $(e).closest('.jsc-menu-accordion-content');
    accordionContent.toggleClass('active');

    var otherMenuContent = accordionContent.parent('.jsc-menu-accordion-content-parent').siblings('.jsc-menu-accordion-content-parent');
    otherMenuContent.each(function(index, item) {
        var content = $(item).find('.jsc-menu-accordion-content');
        if(content.hasClass('active')) {
            content.removeClass('active');
        }
    });
}
// end: footer menu (mobile)

// start: sidebar menu toggle
toggleSubmenu = (evt) => {
    var index = $(evt).attr('data-index');
    var $submenu = $(`.jsc-sidebar-submenu[data-index="${index}"]`);
    var $arrow = $(evt).find('> div .theme-icon');

    if ($submenu.length > 0) {
        $submenu.toggleClass('active');
        $arrow.toggleClass('rotate-90');

        setTimeout(() => {
            var $submenuLink = $submenu.find('.jsc-submenu-link[aria-expanded="false"]');
            $submenuLink.click();
        }, 500);
    }
}
jscPostOpenLeftDrawer = () => {
    // To expand Shop submenu by default
    setTimeout(function() {
        $('#modals-leftDrawer button[aria-expanded="false"]').filter(function() {
            return $(this).find('span').text().trim() === 'Shop';
        }).click();
    }, 200);
}
// end: sidebar menu toggle

// start: complementary product slider
initSlider = ($slider, options) => {
    $($slider).flickity(options);
}

initComplementarySlider = () => {
    var intervalId = setInterval(() => {
        var $relatedProduct = $('.product-block-complementary .related-products ul');
        if ($relatedProduct.length > 0) {
            var options = {
                draggable: true,
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                prevNextButtons: true,
                wrapAround: false,
                cellAlign: 'left'
            }
            initSlider($relatedProduct, options);
            clearInterval(intervalId)
        }
    }, 100);
}
// end: complementary product slider

// start cartJS
cartJSBulkAdd = (items) => {
    CartJS.addItems(items,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            console.log('success');
            $(document).on('cart.requestComplete', function(event, cart) {
                document.dispatchEvent(new CustomEvent('theme:update:cart')); // update cart
                Alpine.store('modals').open('cart'); // open cart drawer
                var itemCount = cart.item_count;
                var $cartBtn = $('#CartButton');
                $cartBtn.find('.jsc-cart-count').text(itemCount);
                $cartBtn.find('.jsc-cart-count').css('display, flex');
                performRecommendations();
            });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", textStatus);

        }
    });
}

cartJSUpdateQuantity = (items) => {
    CartJS.updateItemQuantitiesById(items, {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            console.log('success');
            $(document).on('cart.requestComplete', function(event, cart) {
                document.dispatchEvent(new CustomEvent('theme:update:cart')); // update cart
                Alpine.store('modals').open('cart'); // open cart drawer
                var itemCount = cart.item_count;
                var $cartBtn = $('#CartButton');
                $cartBtn.find('.jsc-cart-count').text(itemCount);
                $cartBtn.find('.jsc-cart-count').css('display, flex');
                performRecommendations();
            });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", textStatus);

        }
    });
}

cartJSAdd = (vid, qty, obj) => {
    CartJS.addItem(vid, qty, obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            console.log('success');
            $(document).on('cart.requestComplete', function(event, cart) {
                document.dispatchEvent(new CustomEvent('theme:update:cart')); // update cart
                Alpine.store('modals').open('cart'); // open cart drawer
                var itemCount = cart.item_count;
                var $cartBtn = $('#CartButton');
                $cartBtn.find('.jsc-cart-count').text(itemCount);
                $cartBtn.find('.jsc-cart-count').css('display, flex');
                performRecommendations();
            });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", textStatus);

        }
    });
}
// end cartJS

// start: product bundle
getActiveCount = ($bundleWrap) => {
    var $activeGrids = $($bundleWrap).find('.jsc-product-bundle__grid.active');
    var limit = parseInt($($bundleWrap).attr('data-limit'));
    var activeCount = 0;

    if ($activeGrids.length > 0) {
        if (limit > 1) {
            $activeGrids.each(function() {
                var $qtySelector = $(this).find('.jsc-product-bundle__qty-selector.active');
                var qty = parseInt($qtySelector.find('.jsc-product-bundle__qty-input').val());
                activeCount += qty;
            });
        }
        else {
            activeCount = $activeGrids.length;
        }
    }

    return activeCount;
}

addBundle = (evt) => {
    var $currentGrid = $(evt).parents('.jsc-product-bundle__grid');
    var $bundleWrap = $(evt).parents('.jsc-product-bundle__wrap');
    var limit = parseInt($bundleWrap.attr('data-limit'));

    var wasActive = $currentGrid.hasClass('active');

    if (wasActive) { 
        $currentGrid.removeClass('active');
        $currentGrid.find('.jsc-product-bundle__button').text('Add');
    }
    else {
        var activeCount = getActiveCount($bundleWrap);

        if (activeCount < limit) {
            $currentGrid.addClass('active');
            if (limit > 1) {
                $currentGrid.find('.jsc-product-bundle__qty-selector').addClass('active');
                $currentGrid.find('.jsc-product-bundle__button').addClass('hide');
            }
            else {
                $currentGrid.find('.jsc-product-bundle__button').text('Added');
            }
        }
    }
  
    recalculateAllBundlesPrice();
    updateBundleButton();
}

recalculateAllBundlesPrice = () => {
    var $allBundles = $('.jsc-product-bundle__wrap');
    var discountPercentage = parseInt($('.jsc-product-bundle').attr('discount-percentage'));
    var mainPriceText = $('.jsc-pdp-price span[data-product-price]').text();
    var discountRate = discountPercentage / 100.0;
    var totalSubtotal = 0;
    var limitsMetCount = 0;

    // Don't add main product to totalSubtotal - only bundle items should be discounted
    var mainPrice = 0;
    if (mainPriceText != undefined) {
      mainPrice = parseFloat(mainPriceText.replace(/[^0-9.-]+/g,"")) || 0;
    }

    $allBundles.each(function() {
        var $bundleWrap = $(this);
        var limit = parseInt($bundleWrap.attr('data-limit'));
        var activeCount = getActiveCount($bundleWrap);
        
        var bundleSubtotal = 0;
        $bundleWrap.find('.jsc-product-bundle__grid.active').each(function() {
            var priceText = $(this).find('.jsc-product-bundle__price .price-item--regular').text();
            var price = parseFloat(priceText.replace(/[^0-9.-]+/g,"")) || 0;
            var qty = parseInt($(this).find('.jsc-product-bundle__qty-input').val()) || 1;
            bundleSubtotal += price * qty;
        });

        totalSubtotal += bundleSubtotal;
        
        if (activeCount >= limit) {
            limitsMetCount++;
        }
    });

    var finalTotal;
    var isDiscountApplied = false;
    
    if (limitsMetCount === $allBundles.length && discountRate > 0) {
      // Apply discount only to bundle items (totalSubtotal)
      finalTotal = totalSubtotal * (1 - discountRate);
      isDiscountApplied = true;
    } else {
        // No discount - just bundle items
        finalTotal = totalSubtotal;
    }

    var $defaultPriceBlock = $('.jsc-pdp-price');
    var $bundlePriceDisplay = $('.jsc-bundle-price-display');

    var samplePriceText = $defaultPriceBlock.find('.text-scheme-text').text();
    var currencySymbol = samplePriceText.match(/^[^\d]+/);
    var formattedCurrency = currencySymbol ? currencySymbol[0].trim() : 'RM';
    
    if (isDiscountApplied) {
        $defaultPriceBlock.hide();
        $bundlePriceDisplay.css('display', 'flex');

        var $mainPrice = $bundlePriceDisplay.find('.jsc-bundle-main-price');
        var $comparePriceContainer = $bundlePriceDisplay.find('.jsc-bundle-compare-price-container');
        var $comparePriceElement = $comparePriceContainer.find('s');
        
        $mainPrice.text(formattedCurrency + finalTotal.toFixed(2));
        $comparePriceContainer.show();
        $comparePriceElement.text(formattedCurrency + totalSubtotal.toFixed(2));
    } else {
        if(finalTotal > 0){
            $defaultPriceBlock.show();
        }else{
            $defaultPriceBlock.hide();
        }
        $bundlePriceDisplay.hide();

        var $defaultMainPrice = $defaultPriceBlock.find('span[data-product-price]');
        $defaultMainPrice.text(formattedCurrency + finalTotal.toFixed(2));
        $defaultPriceBlock.find('s[data-compare-price]').parent().hide();
    }

    var $priceInput = $('.jsc-bundle-total-price');
    $priceInput.val(finalTotal.toFixed(2));
    $priceInput.attr('data-bundle-total-price', finalTotal.toFixed(2));
    $priceInput.attr('data-bundle-subtotal', totalSubtotal.toFixed(2));
}

updateBundleButton = () => {
    var $bundleWrap = $('.jsc-product-bundle .jsc-product-bundle__wrap');
    var $bundleAtc = $('.product-content .jsc-bundle-atc');
    var canAtc = true;
    
    if ($bundleWrap.length > 0) {
        $bundleWrap.each(function() {
            var limit = parseInt($(this).attr('data-limit'));
            var activeCount = getActiveCount($(this));
            var $inactiveGrids = $(this).find('.jsc-product-bundle__grid:not(.active)');

            if (activeCount >= limit) {
                $inactiveGrids.find('.jsc-product-bundle__button:not(.sold-out)').attr('disabled', '');
            }
            else {
                $inactiveGrids.find('.jsc-product-bundle__button:not(.sold-out)').removeAttr('disabled');
                canAtc = false;
            }
        });

        if (canAtc == true) {
            $bundleAtc.removeAttr('disabled');
        }
        else {
            $bundleAtc.attr('disabled', '');
        }
    }
}

minusQty = (evt) => {
    var $qtyInput = $(evt).siblings('.jsc-product-bundle__qty-input');
    var qty = parseInt($qtyInput.val());
    var newQty = qty - 1;
    var $qtySelector = $(evt).parent();
    var $gridButton = $qtySelector.siblings('.jsc-product-bundle__button');
    var $currentGrid = $(evt).parents('.jsc-product-bundle__grid');

    if (newQty <= 0) {
        $currentGrid.removeClass('active');
        $qtySelector.removeClass('active');
        $gridButton.removeClass('hide');
    }
    else {
        $qtyInput.val(newQty)
    }
    updateBundleButton();
}

addQty = (evt) => {
    var $bundleWrap = $(evt).parents('.jsc-product-bundle__wrap');
    var limit = parseInt($bundleWrap.attr('data-limit'));
    var activeCount = getActiveCount($bundleWrap);
    var newActiveCount = activeCount + 1;

    if (newActiveCount <= limit) {
        var $qtyInput = $(evt).siblings('.jsc-product-bundle__qty-input');
        var qty = parseInt($qtyInput.val());
        var newQty = qty + 1;
        $qtyInput.val(newQty);
    }
    updateBundleButton();
}

bundleATC = () => {
    var $activeGrids = $('.jsc-product-bundle .jsc-product-bundle__grid.active');
    if ($activeGrids.length > 0) {
        var items = [];
        var bundleSet = $('.jsc-product-bundle').attr('bundle-set');

        // main item
        var mainID = parseInt($('.product-content form[data-product-form] select[name="id"]').val());
        var seconds = new Date().getTime() / 1000;
        var bindID = mainID + '-' + seconds;
        var mainItem = {
            'id': mainID,
            'quantity': 1,
            'properties': {
                '_MainProduct': 'Yes',
                '_BindID': bindID
            }
        };
        items.push(mainItem);

        // bundle item
        $activeGrids.each(function() {
            var id = parseInt($(this).attr('data-id'));
            var $qtyInput = $(this).find('.jsc-product-bundle__qty-input');
            var qty = parseInt($qtyInput.val());
            var bundleItem = {
                'id': id,
                'quantity': qty,
                'properties': {
                    '_BindID': bindID,
                    '_BundleProduct': 'Yes',
                    '_BundleSet': bundleSet
                }
            };

            items.push(bundleItem);
        });

        cartJSBulkAdd(items);
    }
    else {
        var $appBundleBtn = $('.rbr-bap-new-footer');
        if ($appBundleBtn.length > 0) {
            $appBundleBtn.click();
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent('theme:update:cart')); // update cart
                Alpine.store('modals').open('cart'); // open cart drawer
                var itemCount = cart.item_count;
                var $cartBtn = $('#CartButton');
                $cartBtn.find('.jsc-cart-count').text(itemCount);
                $cartBtn.find('.jsc-cart-count').css('display, flex');
            }, 1000);
        }
    }
}

studentBundleATC = () => {
    var $activeGrids = $('.jsc-product-bundle .jsc-product-bundle__grid.active');
    if ($activeGrids.length > 0) {
        var items = [];

        // main item
        var mainID = parseInt($('.product-content form[data-product-form] select[name="id"]').val());
        var seconds = new Date().getTime() / 1000;
        var bindID = mainID + '-' + seconds;
        console.log("BINDID", bindID);
        var mainItem = {
            'id': mainID,
            'quantity': 1,
            'properties': {
                '_StudentMainProduct': 'Yes',
                '_StudentBindID': bindID
            }
        };
        items.push(mainItem);

        // bundle item
        $activeGrids.each(function() {
            var id = parseInt($(this).attr('data-id'));
            var $qtyInput = $(this).find('.jsc-product-bundle__qty-input');
            var qty = parseInt($qtyInput.val());
            var bundleItem = {
                'id': id,
                'quantity': qty,
                'properties': {
                    '_StudentBindID': bindID,
                    '_StudentBundleProduct': 'Yes'
                }
            };

            items.push(bundleItem);
        });

        cartJSBulkAdd(items);
    }
    else {
        var $appBundleBtn = $('.rbr-bap-new-footer');
        if ($appBundleBtn.length > 0) {
            $appBundleBtn.click();
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent('theme:update:cart')); // update cart
                Alpine.store('modals').open('cart'); // open cart drawer
                var itemCount = cart.item_count;
                var $cartBtn = $('#CartButton');
                $cartBtn.find('.jsc-cart-count').text(itemCount);
                $cartBtn.find('.jsc-cart-count').css('display, flex');
            }, 1000);
        }
    }
}

bundleUpsellATC = () => {
  var $bundleGrid = $('.jsc-product-bundle .jsc-product-bundle__grid');
  var $activeGrids = $('.jsc-product-bundle .jsc-product-bundle__grid.active');
  if ($bundleGrid.length > 0) {
      var bundleSet = $('.jsc-product-bundle.jsc-bundle-upsell').attr('bundle-set');
      var items = [];

      // main item
      var mainID = parseInt($('.product-content form[data-product-form] select[name="id"]').val());
      var seconds = new Date().getTime() / 1000;
      var bindID = mainID + '-' + seconds;
      var mainItem = {
          'id': mainID,
          'quantity': 1,
          'properties': {}
      };
      if ($activeGrids.length > 0) {
        mainItem.properties['_MainProduct'] = 'Yes';
        mainItem.properties['_BundleProduct'] = 'Yes';
        mainItem.properties['_BundleUpsellProduct'] = 'Yes';
        mainItem.properties['_BindID'] = bindID;
        mainItem.properties['_BundleSet'] = bundleSet;
      }
      items.push(mainItem);

      // bundle item
      $activeGrids.each(function() {
          var id = parseInt($(this).attr('data-id'));
          var $qtyInput = $(this).find('.jsc-product-bundle__qty-input');
          var qty = parseInt($qtyInput.val());
          var bundleItem = {
              'id': id,
              'quantity': qty,
              'properties': {
                  '_BundleProduct': 'Yes',
                  '_BundleUpsellProduct': 'Yes',
                  '_BundleSet': bundleSet,
                  '_BindID': bindID
              }
          };

          items.push(bundleItem);
      });

      cartJSBulkAdd(items);
  }
  else {
      var $appBundleBtn = $('.rbr-bap-new-footer');
      if ($appBundleBtn.length > 0) {
          $appBundleBtn.click();
          setTimeout(() => {
              document.dispatchEvent(new CustomEvent('theme:update:cart')); // update cart
              Alpine.store('modals').open('cart'); // open cart drawer
              var itemCount = cart.item_count;
              var $cartBtn = $('#CartButton');
              $cartBtn.find('.jsc-cart-count').text(itemCount);
              $cartBtn.find('.jsc-cart-count').css('display, flex');
          }, 1000);
      }
  }
}

removeBundle = (evt) => {
    var $cartItem = $(evt).parents('.jsc-cart-item');
    var bindID = $cartItem.attr('data-bind-id');
    var $bundleItems = $(`.jsc-cart-item[data-bind-id="${bindID}"]`);
    var removeList = {};

    $bundleItems.each(function() {
        var itemKey = $(this).attr('data-line-item-key');
        removeList[itemKey] = 0;
    });
    cartJSUpdateQuantity(removeList);
}

checkIncompleteBundle = () => {
    var $cartItems = $('.jsc-cart-item');
    var removeList = {};

    $cartItems.each(function() {
        var available = $(this).attr('data-available');
        if (available == false) {
            var bindID = $(this).attr('data-bind-id');
            
            if (bindID != '') {
                var $bundleItems = $(`.jsc-cart-item[data-bind-id="${bindID}"]`);
                $bundleItems.each(function(index, $item) {
                    var itemKey = $($item).attr('data-line-item-key');
                    removeList[itemKey] = 0;
                });
            }
        }
    });

    if (Object.keys(removeList).length > 0) {
        $('.alert_popup_modal').show();
        cartJSUpdateQuantity(removeList);
    }
}

closeAlertPopup = () =>{
    $('.alert_popup_modal').hide();
}

updatePdpBundlePrice = () => {
    var $pdpPrice = $('.jsc-pdp-price[is-bundle-price]');
    if ($pdpPrice.length > 0) {
        var moneyFormat = $pdpPrice.attr('money-format');
        var bundlePrice = parseFloat($pdpPrice.attr('bundle-price'));
        var bundleComparePrice = parseFloat($pdpPrice.attr('bundle-compare-price'));
        
        if (window.Shopify && Shopify.currency) {
            var conversionRate = Shopify.currency.rate;
            var convertedBundlePrice = Math.round(bundlePrice * conversionRate).toFixed(2);
            var convertedBundleComparePrice = Math.round(bundleComparePrice * conversionRate).toFixed(2);
            var formattedBundlePrice = moneyFormat.replace(/\{\{.*?\}\}/, convertedBundlePrice);
            var formattedBundleComparePrice = moneyFormat.replace(/\{\{.*?\}\}/, convertedBundleComparePrice);

            $pdpPrice.find('.jsc-product-price').text(formattedBundlePrice);
            $pdpPrice.find('.jsc-product-compare-price').text(formattedBundleComparePrice);
        }
    }
}

updateBundleSliderHeight = () => {
    var $bundleSlider = $('.jsc-product-bundle .jsc-product-bundle__slider');
    if ($bundleSlider.length > 0) {
        $bundleSlider.each(function() {
            var maxTitleHeight = 0;
            var maxSubtitleHeight = 0;
            var maxVariantHeight = 0;
            var $grid = $(this).find('.jsc-product-bundle__grid');

            $grid.each(function() {
                var $title = $(this).find('.jsc-product-bundle__title');
                var $subtitle = $(this).find('.jsc-product-bundle__color');
                var $variant = $(this).find('.jsc-product-bundle__variant_title');
                var titleHeight = $title.outerHeight();
                var subtitleHeight = $subtitle.outerHeight();
                var variantHeight = $variant.outerHeight();
                
                if (titleHeight > maxTitleHeight) {
                    maxTitleHeight = titleHeight;
                }

                if (subtitleHeight > maxSubtitleHeight) {
                    maxSubtitleHeight = subtitleHeight;
                }

                if (variantHeight > maxVariantHeight) {
                    maxVariantHeight = variantHeight;
                }
            });

            $grid.find('.jsc-product-bundle__title').css('height', maxTitleHeight + 'px');
            $grid.find('.jsc-product-bundle__color').css('height', maxSubtitleHeight + 'px');
            $grid.find('.jsc-product-bundle__variant_title').css('height', maxVariantHeight + 'px');
        });
    }
}
// end: product bundle

updateAppBundleButton = () => {
    setInterval(() => {
        var $appBundleBtn = $('.rbr-bap-new-footer');
        var $bundleAtc = $('.jsc-app-bundle-atc');
        if ($appBundleBtn.children('span').length > 0) {
            $bundleAtc.attr('disabled', '');
        }
        else {
            $bundleAtc.removeAttr('disabled');
        }
    }, 500);
}

toggleCountrySelector = (evt) => {
    var $countrySelector = $(evt).siblings('[country-selector]');
    var $toggleIcon = $(evt).find('[toggle-icon]');
    var isOpen = $countrySelector.attr('open');

    if (isOpen) {
        $countrySelector.removeAttr('open');
        $toggleIcon.removeAttr('open');
    }
    else {
        $countrySelector.attr('open', '');
        $toggleIcon.attr('open', '');
    }
}
// start: collection list
initCollectionListSplide = () => {
    const sliders = document.querySelectorAll('.jsc-collection-list-splide');

    sliders.forEach((slider) => {
        new Splide(slider, {
        type: 'slide',
        gap: '1.5rem',
        arrows: false,
        pagination: false,
        autoWidth: true
        }).mount();
    });
}
// end: collection list

// start: cart recommendations
performRecommendations = () => {
    setTimeout(() => {
        var recommendations = $('.jsc-cart-recommendations');
        if (recommendations.length > 0) {
            var url = recommendations.attr('data-url');
            fetch(url)
                .then(response => response.text())
                .then(text => {
                    var recommendationsHMTL = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector('[data-recommendations]').innerHTML;
                    
                    recommendations.html(recommendationsHMTL);
                    initRecommendationsSplide();
                });
        }
    }, 1000);   
}

initRecommendationsSplide = () => {
    const sliders = document.querySelectorAll('.jsc-cart-recommendations-splide');

    sliders.forEach((slider) => {
        new Splide(slider, {
        type: 'slide',
        gap: '1.5rem',
        arrows: false,
        pagination: false
        }).mount();
    });
}

cartRecommendationATC = (evt) => {
    var $form = $(evt).parents('.quick-buy-product-form');
    var id = parseInt($form.find('input[name="id"]').val());
    cartJSAdd(id, 1, {});
}
// end: cart recommendations

masterPromo = () =>{
  console.log("Initialize cart request master promo");
	$(document).on('cart.requestStarted', function(event, cart) {
		console.log('cart.requestStarted fired');
		$('.jsc-page-loading').show();
	});
	$(document).on('cart.requestComplete', function(event, cart) {
    console.log('cart.requestComplete fired');
    $('.jsc-page-loading').hide();
		document.dispatchEvent(new CustomEvent('theme:update:cart')); // update cart
		Alpine.store('modals').open('cart'); // open cart drawer
		var itemCount = cart.item_count;
		var $cartBtn = $('#CartButton');
		$cartBtn.find('.jsc-cart-count').text(itemCount);
		$cartBtn.find('.jsc-cart-count').css('display, flex');
		performRecommendations();
  });
	addGift();
	removeGift();
	updateGift();
}

cartJSAddQuery = (vid, qty, prop) => {
// Cart js add item, success callback, error callback

CartJS.addItem(vid, qty, prop,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      console.log('Added item to cart');
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown, jqXHR);
    }
  });
}

addGift = () =>{
    console.log("here", $('.jsc-add-gift').length);
    if ($('.jsc-add-gift').length > 0) {
        $('.jsc-add-gift').each(function() {
            console.log("here");
            const varID = $(this).val();
            const varQty = parseInt($(this).attr('data-quantity')) || 1;

            let properties = $(this).attr('data-properties');
            let propsObj = {};
            if (properties) {
                try {
                propsObj = JSON.parse(properties);
                } catch (e) {
                console.warn('Invalid data-properties JSON', e);
                }
            }

            // ✅ Add gift to cart
            cartJSAddQuery(varID, varQty, propsObj);
        });
    }
}
removeGift = () =>{
  if ($('.jsc-remove-gift').length > 0) {
    var jsonObj = {};
    $('.jsc-remove-gift').each(function(){
      var varID = $(this).val();
      jsonObj[varID] = 0;
    });
    CartJS.updateItemQuantitiesById(jsonObj);
  }
}
updateGift = () =>{
  if ($('.jsc-update-gift').length > 0) {
    $('.jsc-update-gift').each(function(){
      var varID = $(this).val();
      var QTY = parseInt($(this).attr('data-quantity'));
      CartJS.updateItemById(varID, QTY);
    });
  }
}
removeGWPItem = (itemKey) =>{
	CartJS.updateItemById(itemKey, 0);
}

initSizeGuideSplide = () => {
    const sliders = document.querySelectorAll('.jsc-size-guide-wrap');

    sliders.forEach((slider) => {
        var maxHeight = 0;
        var $grid = $(slider).find('.splide__slide .jsc-size-guide-grid');
        $grid.each(function(index, $g) {
          var height = $($g).outerHeight(true);
          if (height > maxHeight) {
            maxHeight = height;
          }
        });

        $grid.css('height', maxHeight + 'px');

        new Splide(slider, {
        type: 'slide',
        autoWidth: true,
        gap: '15px',
        arrows: false,
        pagination: false
        }).mount();
    });
}

showRewardPopup = () => {
  window.SmileUI.openPanel();
}

// start: charm set bundle
var selectedCharms = [];
updateCharmSetContent = (evt) => {
  var index = $(evt).attr('index');
  var $otherCharmMenu = $(evt).siblings('.jsc-charm-set-bundle__menu-item');
  var $currentContent = $(evt).parents('.jsc-charm-set-bundle').find(`[jsc-bundle-content][index="${index}"]`);
  var $otherContent = $(evt).parents('.jsc-charm-set-bundle').find(`[jsc-bundle-content]`);

  $otherCharmMenu.removeAttr('active');
  $(evt).attr('active', '');
  $otherContent.removeAttr('active');
  $currentContent.attr('active', '');
}

updateCharmLimit = () => {
  var $activeChain = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__grid[chain-grid][active]:first');
  if ($activeChain.length > 0) {
    var minCharm = parseInt($activeChain.attr('charm-min'));
    var maxCharm = parseInt($activeChain.attr('charm-max'));

    var chainContentIndex = parseInt($activeChain.parents('.jsc-charm-set-bundle__content-wrap').attr('index'));
    var charmContentIndex = chainContentIndex + 1;
    var $charmContent = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${charmContentIndex}"]`);
    if ($charmContent.length > 0) {
      $charmContent.each(function() {
        $(this).attr('item-limit-min', minCharm);
        $(this).attr('item-limit-max', maxCharm);

        var $charmContentTitle = $(this).find('.jsc-charm-set-bundle__content-title');
        if (minCharm == maxCharm) {
          $charmContentTitle.text(`Select a minimum of ${maxCharm} charms`);
        }
        else {
          $charmContentTitle.text(`Select a minimum of ${minCharm} charms, maximum ${maxCharm}`);
        }

        var index = $(this).attr('index');
        var $charmMenu = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__menu-item[index="${index}"]`);
        $charmMenu.find('.jsc-charm-bundle-set__charm-max-number').text(maxCharm);

        var $charmGrid = $(this).find('.jsc-charm-set-bundle__grid');
        $charmGrid.each(function() {
          $(this).find('.jsc-charm-set-bundle__qty-input').attr('max', maxCharm);
        });
      });
    }
  }
}

getCharmSetActiveCount = ($contentWrap) => {
  var $activeGrids = $($contentWrap).find('.jsc-charm-set-bundle__grid[active]');
  var limit = parseInt($($contentWrap).attr('item-limit-max'));
  var activeCount = 0;

  if ($activeGrids.length > 0) {
    if (limit > 1) {
      $activeGrids.each(function() {
        var $qtySelector = $(this).find('.jsc-charm-set-bundle__qty-selector');
        var qty = parseInt($qtySelector.find('.jsc-charm-set-bundle__qty-input').val());
        activeCount += qty;
      });
    }
    else {
      activeCount = $activeGrids.length;
    }
  }
  return activeCount;
}

updateSelectedCharmCount = ($contentWrap) => {
  var activeCount = getCharmSetActiveCount($contentWrap);
  var index = $contentWrap.attr('index');
  var $charmMenu = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__menu-item[index="${index}"]`);
  $charmMenu.find('.jsc-charm-bundle-set__charm-selected-number').text(activeCount);
}

addCharms = ($grid) => {
  var id = $($grid).attr('data-id');
  var overlay = $($grid).attr('data-overlay');
  var index = selectedCharms.length;

  selectedCharms.push({
    'index': index,
    'id': id,
    'overlay': overlay
  });
}

removeCharms = ($grid, isRemoveAll) => {
  var id = $($grid).attr('data-id');

  if (isRemoveAll) {
    selectedCharms = selectedCharms.filter(charm => charm.id != id);
  } else {
    var lastIndex = selectedCharms.findLastIndex(charm => charm.id == id);
    if (lastIndex != -1) {
      selectedCharms.splice(lastIndex, 1);
    }
  }
}

updateCharmSetSelect = (evt) => {
  var $contentWrap = $(evt).parents('.jsc-charm-set-bundle__content-wrap');
  var index = parseInt($contentWrap.attr('index'));
  var $currentContentWrap = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${index}"]`);
  var gridId = $(evt).attr('data-id');
  var limitMin = parseInt($contentWrap.attr('item-limit-min'));
  var limitMax = parseInt($contentWrap.attr('item-limit-max'));

  if (limitMax == 1) {
    if ($(evt).attr('active') == undefined) {
      var charmContentIndex = index + 1;
      var $charmContent = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${charmContentIndex}"]`);
      var $charmGrid = $charmContent.find('.jsc-charm-set-bundle__grid');
      $charmGrid.each(function() {
        $(this).removeAttr('active');
        $(this).find('.jsc-charm-set-bundle__qty-input').val('0');
      });

      $charmContent.each(function() {
        updateSelectedCharmCount($(this));
      });
      selectedCharms = [];
    }

    $currentContentWrap.each(function() {
      var $currentGrid = $(this).find(`.jsc-charm-set-bundle__grid[data-id="${gridId}"]`);
      var $otherGrid = $(this).find('.jsc-charm-set-bundle__grid');
      $otherGrid.removeAttr('active');
      $currentGrid.attr('active', '');
    });
    updateCharmLimit();
  }
  else if (limitMax > 1) {
    var $charmContent = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${index}"]`);
    if ($(evt).attr('active') == undefined) {
      var activeCount = getCharmSetActiveCount($contentWrap);
      if (activeCount < limitMax) {
        $charmContent.each(function() {
          var $currentGrid = $(this).find(`.jsc-charm-set-bundle__grid[data-id="${gridId}"]`);
          $currentGrid.attr('active', '');
          $currentGrid.find('.jsc-charm-set-bundle__qty-input').val('1');
          updateSelectedCharmCount($(this));
        });
        addCharms($(evt));
      }
    }
    else {
      $charmContent.each(function() {
        var $currentGrid = $(this).find(`.jsc-charm-set-bundle__grid[data-id="${gridId}"]`);
        $currentGrid.removeAttr('active');
        $currentGrid.find('.jsc-charm-set-bundle__qty-input').val('0');
        updateSelectedCharmCount($(this));
      });
      removeCharms($(evt), true);
    }
  }

  updateCharmSetBundleButton();
  calculateCharmSetBundlePrice();
  updateCharmOverlayImage();
}

charmSetMinusQty = (event, evt) => {
  event.stopPropagation();

  var $qtyInput = $(evt).siblings('.jsc-charm-set-bundle__qty-input');
  var qty = parseInt($qtyInput.val());
  var newQty = qty - 1;
  var $currentGrid = $(evt).parents('.jsc-charm-set-bundle__grid');
  var gridId = $currentGrid.attr('data-id');
  var $contentWrap = $(evt).parents('.jsc-charm-set-bundle__content-wrap');
  var contentWrapIndex = $contentWrap.attr('index');
  var $grid = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${contentWrapIndex}"] .jsc-charm-set-bundle__grid[data-id="${gridId}"]`);

  if (newQty <= 0) {
    $grid.removeAttr('active');
    newQty = 0;
  }

  $grid.find('.jsc-charm-set-bundle__qty-input').val(newQty);

  var $content = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${contentWrapIndex}"]`);
  $content.each(function() {
    updateSelectedCharmCount($(this));
  });
  removeCharms($currentGrid, false);
  updateCharmSetBundleButton();
  calculateCharmSetBundlePrice();
  updateCharmOverlayImage();
}

charmSetAddQty = (event, evt) => {
  event.stopPropagation();
  
  var $contentWrap = $(evt).parents('.jsc-charm-set-bundle__content-wrap');
  var contentWrapIndex = $contentWrap.attr('index');
  var $currentGrid = $(evt).parents('.jsc-charm-set-bundle__grid');
  var gridId = $currentGrid.attr('data-id');
  var limit = parseInt($contentWrap.attr('item-limit-max'));
  var activeCount = getCharmSetActiveCount($contentWrap);
  var newActiveCount = activeCount + 1;
  var $grid = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${contentWrapIndex}"] .jsc-charm-set-bundle__grid[data-id="${gridId}"]`);

  if (newActiveCount <= limit) {
    var $qtyInput = $(evt).siblings('.jsc-charm-set-bundle__qty-input');
    var qty = parseInt($qtyInput.val());
    var newQty = qty + 1;
    $grid.find('.jsc-charm-set-bundle__qty-input').val(newQty);
    $grid.attr('active', '');
  }

  var $content = $(`.jsc-charm-set-bundle .jsc-charm-set-bundle__content-wrap[index="${contentWrapIndex}"]`);
  $content.each(function() {
    updateSelectedCharmCount($(this));
  });
  addCharms($currentGrid);
  updateCharmSetBundleButton();
  calculateCharmSetBundlePrice();
  updateCharmOverlayImage();
}

updateCharmSetBundleButton = () => {
  var $charmSetWrap = null;
  if ($(window).width() > 480) {
    $charmSetWrap = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__wrap .jsc-charm-set-bundle__desktop-content .jsc-charm-set-bundle__content-wrap');
  }
  else {
    $charmSetWrap = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__wrap .jsc-charm-set-bundle__mobile-content .jsc-charm-set-bundle__content-wrap');
  }
  var $charmAtc = $('.product-content .jsc-charm-set-bundle-atc');
  var canAtc = true;

  if ($charmSetWrap.length > 0) {
    $charmSetWrap.each(function() {
      var minLimit = parseInt($(this).attr('item-limit-min'));
      var maxLimit = parseInt($(this).attr('item-limit-max'));
      var activeCount = getCharmSetActiveCount($(this));

      if (activeCount < minLimit || activeCount > maxLimit) {
        canAtc = false;
      }
    });

    if (canAtc == true) {
      $charmAtc.removeAttr('disabled');
    }
    else {
      $charmAtc.attr('disabled', '');
    }
  }
}

charmSetBundleATC = () => {
  var $activeGrids = null;
  if ($(window).width() > 480) {
    $activeGrids = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__content.jsc-charm-set-bundle__desktop-content .jsc-charm-set-bundle__grid[active]');
  }
  else {
    $activeGrids = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__content.jsc-charm-set-bundle__mobile-content .jsc-charm-set-bundle__grid[active]');
  }
  if ($activeGrids.length > 0) {
      var items = [];

      // main item
      var mainID = parseInt($('.product-content form[data-product-form] select[name="id"]').val());
      var seconds = new Date().getTime() / 1000;
      var bindID = mainID + '-' + seconds;
      var mainItem = {
          'id': mainID,
          'quantity': 1,
          'properties': {
              '_MainProduct': 'Yes',
              '_CharmSetMainProduct': 'Yes',
              '_BindID': bindID
          }
      };
      items.push(mainItem);

      // bundle item
      $activeGrids.each(function() {
          var id = parseInt($(this).attr('data-id'));
          var qty = 1;
          var $qtyInput = $(this).find('.jsc-charm-set-bundle__qty-input');
          if ($qtyInput.length > 0) {
            var qty = parseInt($qtyInput.val());
          }
          var bundleItem = {
              'id': id,
              'quantity': qty,
              'properties': {
                  '_BindID': bindID,
                  '_CharmSetBundle': 'Yes'
              }
          };

          items.push(bundleItem);
      });

      cartJSBulkAdd(items);
  }
}

calculateCharmSetBundlePrice = () => {
  var $charmSetContent = null;
  if ($(window).width() > 480) {
    $charmSetContent = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__desktop-content .jsc-charm-set-bundle__content-wrap');
  }
  else {
    $charmSetContent = $('.jsc-charm-set-bundle .jsc-charm-set-bundle__mobile-content .jsc-charm-set-bundle__content-wrap');
  }
  if ($charmSetContent.length > 0) {
    var canAtc = true;
    var totalPrice = 0;
    var discountRate = 0.15;

    $charmSetContent.each(function() {
      var minLimit = parseInt($(this).attr('item-limit-min'));
      var maxLimit = parseInt($(this).attr('item-limit-max'));
      var activeCount = getCharmSetActiveCount($(this));

      if (activeCount < minLimit || activeCount > maxLimit) {
        canAtc = false;
      }

      var $activeGrids = $(this).find('.jsc-charm-set-bundle__grid[active]');
      $activeGrids.each(function(index, $grid) {
        var price = parseInt($($grid).attr('data-price'));
        var $qtyInput = $($grid).find('.jsc-charm-set-bundle__qty-input');
        if ($qtyInput.length > 0) {
          var qty = parseInt($qtyInput.val());
          price = price * qty;
        }
        totalPrice = totalPrice + price;
      });
    });

    var discountedPrice = totalPrice * (1 - discountRate);
    var formattedTotalPrice = (totalPrice / 100).toFixed(2);
    var formattedDiscountPrice = (discountedPrice / 100).toFixed(2);

    var $defaultPriceBlock = $('.jsc-pdp-price');
    var $bundlePriceDisplay = $('.jsc-bundle-price-display');
    var $atcButtonPrice = $('.jsc-charm-set-bundle-atc');
    var samplePriceText = $defaultPriceBlock.find('.text-scheme-text').text();
    var currencySymbol = samplePriceText.match(/^[^\d]+/);
    var formattedCurrency = currencySymbol ? currencySymbol[0].trim() : 'RM';

    if (canAtc == true) {
      $defaultPriceBlock.hide();
      $bundlePriceDisplay.css('display', 'flex');

      var $mainPrice = $bundlePriceDisplay.find('.jsc-bundle-main-price');
      var $comparePriceContainer = $bundlePriceDisplay.find('.jsc-bundle-compare-price-container');
      var $comparePriceElement = $comparePriceContainer.find('s');

      $mainPrice.text(formattedCurrency + formattedDiscountPrice);
      $comparePriceContainer.show();
      $comparePriceElement.text(formattedCurrency + formattedTotalPrice);

      $atcButtonPrice.find('.jsc-charm-set-bundle-atc-price').text(formattedCurrency + formattedDiscountPrice);
      $atcButtonPrice.find('.jsc-charm-set-bundle-atc-compare-price').show();
      $atcButtonPrice.find('.jsc-charm-set-bundle-atc-compare-price [data-compare-price]').text(formattedCurrency + formattedTotalPrice);
    }
    else {
      $defaultPriceBlock.show();
      $bundlePriceDisplay.hide();

      var $defaultMainPrice = $defaultPriceBlock.find('span[data-product-price]');
      $defaultMainPrice.text(formattedCurrency + formattedTotalPrice);
      $defaultPriceBlock.find('s[data-compare-price]').parent().hide();

      $atcButtonPrice.find('.jsc-charm-set-bundle-atc-price').text(formattedCurrency + formattedTotalPrice);
      $atcButtonPrice.find('.jsc-charm-set-bundle-atc-compare-price').hide();
      $atcButtonPrice.find('.jsc-charm-set-bundle-atc-compare-price [data-compare-price]').text('');
    }
  }
}

updateCharmOverlayImage = () => {
  var $charmSetBundle = $('.jsc-charm-set-bundle');
  if ($charmSetBundle.length > 0) {
    var $overlayImageCont = $('.section-product .product-media .jsc-product-overlay-image .media:first');
    var $originalImageEl = $overlayImageCont.find('img:not(.jsc-appended-image)');
    var $charmContent = null;
    if ($(window).width() > 480) {
      $charmContents = $charmSetBundle.find('.jsc-charm-set-bundle__desktop-content .jsc-charm-set-bundle__content-wrap');
    }
    else {
      $charmContents = $charmSetBundle.find('.jsc-charm-set-bundle__mobile-content .jsc-charm-set-bundle__content-wrap');
    }

    $overlayImageCont.find('.jsc-appended-image').remove();
    var overlayPosition = undefined;
    var overlaySize = undefined;
    $charmContents.each(function(index, $contentWrap) {
      if (index == 0) {
        var $activeGrids = $($contentWrap).find('.jsc-charm-set-bundle__grid[active]');
        $activeGrids.each(function(gridIndex) {
          var overlayImage = $(this).attr('data-overlay');
          if (overlayImage != undefined) {
            var $overlayImgEl = $originalImageEl.clone(true);
            $overlayImgEl.attr('src', overlayImage);
            $overlayImgEl.removeAttr('srcset');
            $overlayImgEl.addClass('jsc-appended-image');
            $overlayImgEl.addClass('jsc-overlay-chain-image');
            $overlayImgEl.removeClass('jsc-overlay-charm-image');
            overlayPosition = $(this).attr('overlay-position');
            overlaySize = $(this).attr('overlay-size');
            $overlayImageCont.append($overlayImgEl);
          }
        });
      }
      else {
        selectedCharms.forEach(function(charm, index) {
          var overlayImage = charm.overlay;
          if (overlayImage != undefined) {
            var $overlayImgEl = $originalImageEl.clone(true);
            $overlayImgEl.attr('src', overlayImage);
            $overlayImgEl.removeAttr('srcset');
            $overlayImgEl.addClass('jsc-appended-image');
            $overlayImgEl.addClass('jsc-overlay-charm-image');
            $overlayImgEl.removeClass('jsc-overlay-chain-image');

            if (overlayPosition != undefined) {
              var positionList = overlayPosition.split('-');
              var currentPosition = positionList[index];
              var top = parseFloat(currentPosition.split(',')[0]);
              var left = parseFloat(currentPosition.split(',')[1]);
              var rotate = parseFloat(currentPosition.split(',')[2]);
              $overlayImgEl.css('top', `${top}%`);
              $overlayImgEl.css('left', `${left}%`);
              $overlayImgEl.css('transform', `rotate(${rotate}deg)`);
            }

            if (overlaySize != undefined) {
              $overlayImgEl.css('width', overlaySize);            
            }
            else {
              $overlayImgEl.css('width', '17%');
            }

            $overlayImageCont.append($overlayImgEl);
          }
        });
      }
    });
  }
}

showZoomImage = (evt) => {
  var imgSrc = $(evt).find('img').attr('src');
  var $imagePopup = $('.jsc-zoom-image__popup');
  var $overlay = $('.jsc-overlay');

  var $newImageEl = $('<img>');
  $newImageEl.attr('src', imgSrc);

  $imagePopup.find('.jsc-zoom-image__popup-inner').html('');
  $imagePopup.find('.jsc-zoom-image__popup-inner').append($newImageEl);

  $imagePopup.addClass('active');
  $overlay.addClass('active');
}

closeZoomImage = () => {
  var $imagePopup = $('.jsc-zoom-image__popup');
  var $overlay = $('.jsc-overlay');

  $imagePopup.removeClass('active');
  $overlay.removeClass('active');
}
// end: charm set bundle

textColumnAtc = (evt, event) => {
  event.preventDefault();
  var id = parseInt($(evt).attr('data-id'));
  cartJSAdd(id, 1, {});
}